import _typeof from "@babel/runtime/helpers/typeof";

/**
 * @file getUniqueKey Get the unique key of an object.
 * @author yuzong(yuzong@tencent.com)
 */
import { guid } from './guid';
var UNIQUE_KEY_REF = Symbol('unique_key_ref');
/**
 * Get the unique key of an object.
 * For the same object, the same string must be returned, and different objects must be different.
 *
 * @param obj The source object.
 * @return Unique Key.
 */

export function getUniqueKey(obj) {
  if (typeof obj !== 'function' && _typeof(obj) !== 'object') {
    return "".concat(_typeof(obj), " - ").concat(String(obj));
  }

  if (obj == null) {
    return String(obj) + ' - ' + String(null);
  }

  var map = obj;

  if (UNIQUE_KEY_REF in map) {
    return map[UNIQUE_KEY_REF];
  }

  var id = "object - ".concat(guid());
  Object.defineProperty(obj, UNIQUE_KEY_REF, {
    value: id,
    writable: false,
    enumerable: false,
    configurable: false
  });
  return id;
}